var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "b-sidebar",
        {
          attrs: {
            id: "sidebar-border",
            "sidebar-class": "border-right border-danger"
          }
        },
        [
          _c("div", { staticClass: "px-3 py-2" }, [
            _c("p", [
              _vm._v(
                "\n        Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus,\n        porta ac consectetur ac, vestibulum at eros.\n      "
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("ribbon"),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "app-header" } },
        [_c("jhi-navbar"), _vm._v(" "), _c("jhi-sidebar")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "card jh-card" }, [_c("router-view")], 1)
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }